<template>
    <modal ref="modal" @close="goBack()" :content-class="'md:mt-10'">
        <div class="flex h-full w-full bg-purple-900 items-center justify-center text-white">
            <div v-if="loading">
                <div class="loader"></div>
            </div>

            <div v-show="!loading">
                <div class="flex">
                    <div>
                        <component :is="methodComponent"
                                   :plan="plan"
                                   ref="method"
                                   @finishes="finish"></component>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Card from "./Card.vue";
    import Boleto from "./Boleto.vue";
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            plan: String,
            method: String
        },

        inject: ['alert'],

        components: {
            Card,
            Boleto
        },

        data() {
            return {
                loading: false,
                methodComponent: null
            }
        },

        mounted() {
            this.$refs.modal.open();

            if(this.method === 'pagarme_cc') {
                this.methodComponent = 'card';
            }

            if(this.method === 'pagarme_boleto') {
                this.methodComponent = 'boleto';
            }
        },

        methods: {
            goBack() {
                history.go(-1);
            },

            finish(e) {
                this.loading = true;

                if(e.type === 'card') {
                    Zapin
                        .payments()
                        .pagarme()
                        .payWithCard(this.plan, e.card)
                        .then((res) => {
                            this.alert.success(res.data.message);
                            this.successfully();
                        })
                        .catch(err => {
                            this.loading = false;

                            if(err.status === 422) {
                                this.alert.showValidationErrors(err.data);
                            } else if (err.data.data && err.data.data.message) {
                                this.alert.show(err.data.data.message);
                            } else {
                                this.alert.show('Ocorreu um erro desconhecido. Cheque as informações inseridas e se o problema persistir, entre em contato conosco.');
                            }
                        });
                }

                if(e.type === 'boleto') {
                    Zapin.payments()
                        .pagarme()
                        .generateBoleto(this.plan, e.document_number)
                        .then(res => {
                            this.alert.success(res.data.message);
                            this.successfully();
                        })
                        .catch(err => {
                            this.loading = false;

                            if(err.status === 422) {
                                this.alert.showValidationErrors(err.data);
                            } else if(err.data.data && err.data.data.message) {
                                this.alert.show(err.data.data.message);
                            } else {
                                this.alert.show('Ocorreu um erro desconhecido. Cheque as informações inseridas e se o problema persistir, entre em contato conosco.');
                            }
                        })
                }
            },

            successfully() {
                Zapin
                    .updateUserData()
                    .then(() => {
                        this.loading = false;

                        this.$router.push({
                            name: 'Dashboard'
                        });
                    })
            }
        }
    }
</script>